import React from 'react';
import _ from 'lodash';

var Api = require('./Config');
import { Line as LineChart, Bar as BarChart } from 'react-chartjs-2';
import AsthmaControlChart, { getAstControlLabels } from './AsthmaControlChart';

const NORMAL_TYPE = 'normaltype';
const BP_H = 'BP_H';
const BP_L = 'BP_L';
const EAT_OUT = 'EAT_OUT';
const EAT_GOOD = 'EAT_GOOD';
const SUGAR = 'sugar';
const VERTICAL = 'vertical';
const GRAPH = 'GRAPH';
const DAYS = 'DAYS';
const OXYGEN = 'OXYGEN';
const FEVER = 'FEVER';
const PEAK_FLOW = 'PEAK_FLOW';
const AST_CONTROL = 'AST_CONTROL';
const PHQ9 = 'PHQ9';
const FIBSER = 'FIBSER';
const WEIGHT = 'WEIGHT';

import { saveAs } from './FileSaver';

const timeRangeLabel = {
  ALL: 'All Time',
  LAST4: 'Last 4 weeks',
  LAST8: 'Last 8 weeks',
};

export default class AppJGraph extends React.Component {
  constructor(props) {
    super(props);
    this.t_code = props.tcode || props.match.params.tcode;
    this.filter = props.timeRange || 'ALL';
    this.maxSlice = props.maxSlice || 0;
    this.state = {
      data: [],
      loaded: false,
      graphs: [],
      average: [],
      journeyName: '',
      patientRef: '',
      fullPatientRef: '',
      weightBaseline: null,
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps(props) {
    this.t_code = props.tcode || props.match.params.tcode;
    this.filter = props.timeRange || 'ALL';
    this.getData();
  }

  downloadCSV(type) {
    let filteredData = this.state.graphs.filter((graphItem) => graphItem.type === type);

    // no data, nothing to process
    if (filteredData.length < 1) {
      return;
    }

    // should only have 1 graph data per type
    let graphData = filteredData[0];

    let data1 = [];
    let data2 = [];
    if (graphData.datasets) {
      if (type != BP_H) {
        data1 = graphData.datasets[0]['data'];

        // only these types that should have a second data set
        if (type == EAT_OUT) {
          data2 = graphData.datasets[1]['data'];
        }
      } else {
        data1 = graphData.datasets[1]['data'];
        data2 = graphData.datasets[0]['data'];
      }
    }

    let labels = [];
    if (graphData.labelTime && graphData.labelTime.length > 0) {
      labels = graphData.labelTime.map((item) => Api.getDateFormat(item, false, 'mm/dd/yy h:MM tt'));
    }

    // var data = this.data.data;
    // var keys = _.keys(data);
    var text =
      'Pt#: ' +
      this.state.patientRef +
      '\r\n' +
      'T-Code: ' +
      this.t_code +
      ',,' +
      'Journey: ' +
      this.state.journeyName +
      '\r\n';

    if (type === WEIGHT && this.state.weightBaseline) {
      text += 'Weight Baseline: ' + this.state.weightBaseline + '\r\n';
    }

    const averageData = this.state.average.filter((item) => {
      if (type === BP_H) {
        return [BP_H, BP_L].includes(item.type);
      }

      return item.type === type;
    });

    // add averaging in csv
    const avgArr = averageData.map((item) => item.label + ': ' + item.avg);
    text += avgArr.join('\r\n') + '\r\n\r\n';

    var header = ['Reply Date'];
    var mainDatas = [];
    if (type == BP_H) {
      header.push('Systolic');
      header.push('Diastolic');
    }
    if (type == EAT_OUT) {
      header.push('Eating out');
      header.push('Fruits/Veg');
    }
    if (type == SUGAR) {
      header.push('Blood Sugar Level');
    }

    if (type == PEAK_FLOW) {
      header.push('Peak Flow');
    }
    if (type == AST_CONTROL) {
      header.push('Asthma Control');
    }

    if (type == PHQ9) {
      header.push('PHQ-9');
    }
    if (type == FIBSER) {
      header.push('FIBSER');
    }

    if (type == OXYGEN) {
      header.push('%SpO2');
    }
    if (type == FEVER) {
      header.push('Temperature');
    }

    if (type == DAYS) {
      header.push('Days prescriptions taken');
    }

    if (type == WEIGHT) {
      header.push('Weight');
    }

    text += header.join(',');
    text += '\r\n';

    _.each(data1, (item, index) => {
      let datas = [];
      datas.push(labels[index]);

      // Get text description for asthma control
      if (type == AST_CONTROL) {
        item = getAstControlLabels(item, true);
      }

      datas.push(item);

      if (data2.length > 0) {
        datas.push(data2[index]);
      }

      if (datas.length > 1) {
        mainDatas.push(datas.join(','));
      }
    });
    text += mainDatas.join('\r\n');
    // console.log(text);

    var blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, new Date() + '-' + this.getFileName(type) + '-report.csv');
  }

  getFileName(type) {
    var names = {
      sugar: 'Blood Sugar',
      PEAK_FLOW: 'Peak Flow',
      AST_CONTROL: 'Asthma Control',
      EAT_OUT: 'Nutrition',
      DAYS: 'Prescriptions',
      BP_H: 'Blood Pressure',
      EAT_OUT: 'Nutrition',
      OXYGEN: 'spo2',
      FEVER: 'Temperature',
      WEIGHT: 'Weight',
    };
    return names[type];
  }

  getLabelHtml(type, headerLabel, legendLabels) {
    const averageData = this.state.average.filter((item) => {
      if (type === BP_H) {
        return [BP_H, BP_L].includes(item.type);
      }

      return item.type === type;
    });

    return (
      <div style={{ marginTop: 30, marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: 10 }}>
          <div style={{ fontSize: 16, fontWeight: 'bold', width: 300 }}>{headerLabel}</div>
          {this.props.fromPortal && (
            <div>
              <button
                onClick={() => {
                  this.downloadCSV(type);
                }}
                className="btn btn-primary btn-sm"
              >
                Download CSV
              </button>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', marginBottom: 20 }}>
          <div style={{ width: 300 }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {legendLabels.map((legend) => (
                <React.Fragment>
                  <div
                    ref={(element) => {
                      if (element) {
                        // background color needs to have !important so this component will show in print preview
                        element.style.setProperty('height', '10px');
                        element.style.setProperty('width', '10px');
                        element.style.setProperty('background-color', legend.color, 'important');
                        element.style.setProperty('margin-right', '10px');
                      }
                    }}
                  />
                  <div style={{ marginRight: 10 }}>{legend.text}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
          {this.props.fromPortal && averageData.length > 0 && (
            <div>
              <div>
                <strong>Time Range:</strong> {timeRangeLabel[this.filter]}
              </div>
              {averageData.map((item) => {
                return (
                  <div>
                    <strong>{item.label}:</strong> {item.avg}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  getLabel(type) {
    if (type == EAT_OUT) {
      return this.getLabelHtml(EAT_OUT, 'Nutrition', [
        { text: 'Fruits/Veg', color: '#A4B370' },
        { text: 'Eating out', color: '#AB0D22' },
      ]);
    }

    if (type == BP_H) {
      return this.getLabelHtml(BP_H, 'Blood Pressure', [
        { text: 'Systolic', color: 'rgba(0,49,229,.4)' },
        { text: 'Diastolic', color: 'rgba(233,0,0,.8)' },
      ]);
    }

    if (type == SUGAR) {
      return this.getLabelHtml(SUGAR, 'Blood Sugar', [{ text: 'Blood Sugar Level', color: 'rgba(0,49,229,.5)' }]);
    }

    if (type == PEAK_FLOW) {
      return this.getLabelHtml(PEAK_FLOW, 'Peak Flow', [{ text: 'Peak Flow', color: 'rgba(0,49,229,.5)' }]);
    }

    if (type == AST_CONTROL) {
      return this.getLabelHtml(AST_CONTROL, 'Asthma Control', []);
    }

    if (type == PHQ9) {
      return this.getLabelHtml(PHQ9, 'PHQ-9', [{ text: 'PHQ-9 Score', color: 'rgba(0,49,229,.5)' }]);
    }

    if (type == FIBSER) {
      return this.getLabelHtml(FIBSER, 'FIBSER', [{ text: 'FIBSER Score', color: 'rgba(0,49,229,.5)' }]);
    }

    if (type == OXYGEN) {
      return this.getLabelHtml(OXYGEN, '%SpO2', [{ text: '%Sp02', color: 'rgba(0,49,229,.5)' }]);
    }

    if (type == FEVER) {
      return this.getLabelHtml(FEVER, 'Temperature', [{ text: 'Temperature', color: '#AB0D22' }]);
    }

    if (type == DAYS) {
      return this.getLabelHtml(DAYS, 'Prescriptions', [
        { text: 'Days prescriptions taken', color: 'rgba(0,49,229,.5)' },
      ]);
    }

    if (type == WEIGHT) {
      return this.getLabelHtml(WEIGHT, 'Weight', []);
    }
  }

  getChart() {
    if (!this.state.graphs) {
      return;
    }

    if (this.state.graphs.length == 0) return;

    let scaleStartValue = [];
    scaleStartValue[DAYS] = 0;
    scaleStartValue[BP_H] = 40;
    scaleStartValue[SUGAR] = 40;
    scaleStartValue[PEAK_FLOW] = 40;
    scaleStartValue[EAT_OUT] = 0;
    scaleStartValue[OXYGEN] = 70;
    scaleStartValue[FEVER] = 90;
    scaleStartValue[FIBSER] = 0;
    scaleStartValue[WEIGHT] = 0;

    let scaleSteps = [];
    scaleSteps[DAYS] = 2;
    scaleSteps[BP_H] = 20;
    scaleSteps[SUGAR] = 20;
    scaleSteps[PEAK_FLOW] = 20;
    scaleSteps[EAT_OUT] = 1;
    scaleSteps[FEVER] = 0.5;
    scaleSteps[OXYGEN] = 1;
    scaleSteps[FIBSER] = 1;
    scaleSteps[WEIGHT] = 1;

    let heights = [];
    heights[DAYS] = 400;
    heights[BP_H] = 400;
    heights[SUGAR] = 400;
    heights[EAT_OUT] = 400;
    heights[PEAK_FLOW] = 400;
    heights[FEVER] = 400;
    heights[OXYGEN] = 400;
    heights[AST_CONTROL] = 400;
    heights[PHQ9] = 400;
    heights[FIBSER] = 400;
    heights[WEIGHT] = 400;

    let maxes = [];
    maxes[DAYS] = 7;
    maxes[BP_H] = 220;
    maxes[SUGAR] = 300;
    maxes[EAT_OUT] = 3;
    maxes[PEAK_FLOW] = 500;
    maxes[OXYGEN] = 100;
    maxes[FEVER] = 108;
    maxes[FIBSER] = 6;

    let mins = [];
    mins[PEAK_FLOW] = 75;
    mins[OXYGEN] = 75;
    mins[FEVER] = 90;
    mins[FIBSER] = 0;

    let stepSizes = [];
    stepSizes[PEAK_FLOW] = 25;
    stepSizes[OXYGEN] = 1;
    stepSizes[FEVER] = 0.5;
    stepSizes[FIBSER] = 1;

    return (
      <div>
        <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>T-Code: {this.t_code}</div>
        <div>PT REF#: {this.state.fullPatientRef}</div>
        <div>
          {this.state.graphs.map((graph, index) => {
            // line stops plotting at a certain width: 16390
            // this is to make sure that all points are plotted
            // when the calculated width is longer than max
            let width = graph.labels.length * 80 + 100;
            if (width > 16390) {
              width = 16390;
            }

            return (
              <div key={'chartdiv' + index} style={{ pageBreakAfter: 'always' }}>
                {this.getLabel(graph.type)}
                <div style={{ marginLeft: 30 }}>
                  {graph.type == DAYS && (
                    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'none' }}>
                      <BarChart
                        data={graph}
                        options={{
                          scales: {
                            yAxes: [
                              {
                                ticks: {
                                  beginAtZero: false,
                                  min: 0,
                                  max: 7,
                                },
                              },
                            ],
                          },
                          legend: {
                            display: false,
                          },
                          responsive: false,
                          scaleOverride: true,
                          scaleSteps: 7,
                          scaleStepWidth: 1,
                          scaleStartValue: scaleStartValue[graph.type],
                          plugins: {
                            datalabels: {
                              display: false,
                            },
                          },
                          tooltips: {
                            callbacks: {
                              beforeTitle: function (tooltipItems, data) {
                                return Api.getDateFormat(graph.labelTime[tooltipItems[0].index], false, 'h:MM tt');
                              },
                            },
                          },
                        }}
                        width={graph.labels.length * 80 + 100}
                        height={heights[graph.type]}
                      />
                    </div>
                  )}

                  {graph.type != DAYS &&
                    graph.type != EAT_OUT &&
                    graph.type != AST_CONTROL &&
                    graph.type != PHQ9 &&
                    graph.type != WEIGHT && (
                      <div style={{ width: '100%', overflowX: 'auto', overflowY: 'none' }}>
                        <LineChart
                          data={graph}
                          options={{
                            pan: {
                              enabled: false,
                              mode: 'y',
                              rangeMin: {
                                x: null,
                                y: null,
                              },
                              rangeMax: {
                                x: null,
                                y: null,
                              },
                              onPan: () => {
                                console.log('I was panned!!!');
                              },
                            },
                            zoom: {
                              enabled: false,
                              drag: false,
                              mode: 'x',
                              rangeMin: {
                                x: 0,
                                y: 0,
                              },
                              rangeMax: {
                                x: null,
                                y: null,
                              },
                              onZoom: () => {
                                console.log('I was zoomed!!!');
                              },
                            },
                            legend: {
                              display: false,
                            },
                            scales: {
                              yAxes: [
                                {
                                  ticks: {
                                    beginAtZero: false,
                                    min: mins[graph.type] != null ? mins[graph.type] : 40,
                                    max: maxes[graph.type],
                                    stepSize: stepSizes[graph.type] || 20,
                                  },
                                },
                              ],
                            },
                            responsive: false,
                            scaleOverride: false,
                            scaleSteps: scaleSteps[graph.type],
                            scaleStepWidth: 10,
                            scaleStartValue: scaleStartValue[graph.type],
                            devicePixelRatio: 1.5,
                            plugins: {
                              datalabels: {
                                display: false,
                              },
                            },
                            tooltips: {
                              callbacks: {
                                beforeTitle: function (tooltipItems, data) {
                                  return Api.getDateFormat(graph.labelTime[tooltipItems[0].index], false, 'h:MM tt');
                                },
                              },
                            },
                          }}
                          width={width}
                          height={heights[graph.type]}
                        />
                      </div>
                    )}

                  {graph.type == EAT_OUT && (
                    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'none' }}>
                      <BarChart
                        data={graph}
                        options={{
                          pan: {
                            enabled: false,

                            mode: 'y',
                            rangeMin: {
                              x: null,
                              y: null,
                            },
                            rangeMax: {
                              x: null,
                              y: null,
                            },
                            onPan: () => {
                              console.log('I was panned!!!');
                            },
                          },

                          zoom: {
                            enabled: false,
                            drag: false,
                            mode: 'x',
                            rangeMin: {
                              x: 0,
                              y: 0,
                            },
                            rangeMax: {
                              x: null,
                              y: null,
                            },
                            onZoom: () => {
                              console.log('I was zoomed!!!');
                            },
                          },

                          legend: {
                            display: false,
                          },

                          scales: {
                            yAxes: [
                              {
                                ticks: {
                                  beginAtZero: false,
                                  min: mins[graph.type] || 40,
                                  max: maxes[graph.type],
                                },
                              },
                            ],
                          },

                          responsive: false,
                          scaleOverride: false,
                          scaleSteps: scaleSteps[graph.type],
                          scaleStepWidth: 10,
                          scaleStartValue: scaleStartValue[graph.type],
                          plugins: {
                            datalabels: {
                              display: false,
                            },
                          },
                          tooltips: {
                            callbacks: {
                              beforeTitle: function (tooltipItems, data) {
                                return Api.getDateFormat(graph.labelTime[tooltipItems[0].index], false, 'h:MM tt');
                              },
                            },
                          },
                        }}
                        width={graph.labels.length * 80 + 100}
                        height={heights[graph.type]}
                      />
                    </div>
                  )}

                  {graph.type == AST_CONTROL && (
                    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'none' }}>
                      <AsthmaControlChart
                        data={graph}
                        width={width}
                        height={heights[graph.type]}
                        leftPadding={60}
                        displayTime={true}
                      />
                    </div>
                  )}

                  {graph.type == PHQ9 && (
                    <div style={{ width: '100%', overflowX: 'auto', overflowY: 'none' }}>
                      <BarChart
                        data={graph}
                        options={{
                          legend: {
                            display: false,
                          },
                          scales: {
                            yAxes: [
                              {
                                ticks: {
                                  beginAtZero: true,
                                },
                              },
                            ],
                          },
                          responsive: false,
                          plugins: {
                            datalabels: {
                              display: false,
                            },
                          },
                          tooltips: {
                            callbacks: {
                              beforeTitle: function (tooltipItems, data) {
                                return Api.getDateFormat(graph.labelTime[tooltipItems[0].index], false, 'h:MM tt');
                              },
                            },
                          },
                        }}
                        width={graph.labels.length * 80 + 100}
                        height={heights[graph.type]}
                      />
                    </div>
                  )}

                  {graph.type == WEIGHT && (
                    <div style={{ maxWidth: 600 }}>
                      <div className="row">
                        <div className="col-xs-4 table-weight-baseline">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>Baseline Weight</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{this.state.weightBaseline}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="col-xs-8 table-weight">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Weight</th>
                              </tr>
                            </thead>
                            <tbody>
                              {_.map(graph.datasets[0].data, (weightItem, index) => {
                                return (
                                  <tr>
                                    <td>{graph.labels[index]}</td>
                                    <td>{weightItem}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  getSlicedData(data, max = 14) {
    data = data.reverse();
    data = _.slice(data, 0, max);
    data = data.reverse();
    return data;
  }

  getData() {
    const calculatedDataTypes = [AST_CONTROL, PHQ9, FIBSER];

    //  alert( this.filter);
    Api.getChartDetail(this.t_code, this.filter)
      .then((data) => {
        this.data = data;
        this.state.journeyName = data.journeyName;
        this.state.patientRef = data.patientRef;
        this.state.fullPatientRef = data.full_patient_ref;
        this.state.weightBaseline = data.weight_baseline;
        var data = data.data;

        var graphData = {};
        this.state.graphs = [];
        var realKeys = {};
        var timeKeys = {};

        _.each(data, (items, key) => {
          _.each(items, (object) => {
            var type = object.type;

            if (graphData[type] == null) {
              graphData[type] = [];
              realKeys[type] = [];
              timeKeys[type] = [];
            }

            if (object.answer) {
              realKeys[type].push(object.date);

              if (calculatedDataTypes.includes(type)) {
                if (graphData[type][key] == null) {
                  graphData[type][key] = [];
                }

                graphData[type][key].push({
                  date: object.date,
                  question: object.question,
                  answer: object.answer,
                  dateTime: object.dateTime,
                });
              } else {
                timeKeys[type].push(object.dateTime);
                graphData[type].push(object.answer);
              }
            }
          });
        });

        const average = [];
        const averageDataTypes = {
          BP_L: 'Diastolic',
          BP_H: 'Systolic',
          sugar: 'Blood Sugar',
          PEAK_FLOW: 'Peak Flow',
        };

        _.each(graphData, (dataItem, type) => {
          if (Object.keys(averageDataTypes).includes(type)) {
            const total = dataItem.reduce((acc, item) => acc + parseInt(item), 0);
            const avg = parseFloat(total / dataItem.length).toFixed(2);
            average.push({
              label: 'Average ' + averageDataTypes[type],
              avg: avg,
              type: type,
            });
          }
        });

        if (this.maxSlice > 0) {
          graphData = Object.keys(graphData).reduce((acc, item) => {
            const graphItems = graphData[item].filter((graphItem) => graphItem != null);
            acc[item] = this.getSlicedData(graphItems, this.maxSlice);
            return acc;
          }, {});

          realKeys = Object.keys(realKeys).reduce((acc, item) => {
            acc[item] = this.getSlicedData(realKeys[item], this.maxSlice);
            return acc;
          }, {});
        }

        this.state.average = average;

        //debugger;
        var data1 = [],
          data2 = [];

        if (graphData[BP_L]) {
          data2 = graphData[BP_L];
          data1 = graphData[BP_H];
          let dataset = [
            {
              label: 'Diastolic',
              fill: true,
              backgroundColor: 'rgba(233,0,0,1)',
              borderColor: 'rgba(233,0,0,1)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              data: data2,
            },
            {
              label: 'Systolic',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              data: data1,
            },
          ];
          this.state.graphs.push({ labels: realKeys[BP_H], datasets: dataset, type: BP_H, labelTime: timeKeys[BP_H] });
        }

        if (graphData[SUGAR]) {
          data1 = graphData[SUGAR];
          let dataset = [
            {
              label: 'Blood glucose level',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,

              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: realKeys[SUGAR],
            datasets: dataset,
            type: SUGAR,
            labelTime: timeKeys[SUGAR],
          });
        }

        if (graphData[PEAK_FLOW]) {
          data1 = graphData[PEAK_FLOW];
          let dataset = [
            {
              label: 'Peak Flow',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,

              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: realKeys[PEAK_FLOW],
            datasets: dataset,
            type: PEAK_FLOW,
            labelTime: timeKeys[PEAK_FLOW],
          });
        }

        if (graphData[AST_CONTROL]) {
          let astControlKeys = [];
          let astControlTime = [];

          // group the answers by day
          data1 = graphData[AST_CONTROL].reduce((acc, group, index) => {
            astControlTime.push(graphData[AST_CONTROL][index][0].dateTime);
            astControlKeys.push(graphData[AST_CONTROL][index][0].date);
            acc.push(Api.getAstControlValue(group));
            return acc;
          }, []);

          let dataset = [
            {
              label: 'Asthma Control',
              fill: false,
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              lineTension: 0,
              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: astControlKeys,
            datasets: dataset,
            type: AST_CONTROL,
            labelTime: astControlTime,
          });
        }

        if (graphData[DAYS]) {
          data1 = _.map(graphData[DAYS], (a) => {
            return Api.getDayValue(a);
          });
          //?
          let dataset = [
            {
              label: 'days ',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              data: data1,
            },
          ];

          this.state.graphs.push({ labels: realKeys[DAYS], datasets: dataset, type: DAYS, labelTime: timeKeys[DAYS] });
        }

        if (graphData[OXYGEN]) {
          data1 = graphData[OXYGEN];

          let dataset = [
            {
              label: '%SpO2',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(0,49,229,.5)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              borderWidth: 5,
              type: 'line',
              fill: false,
              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: realKeys[OXYGEN],
            datasets: dataset,
            type: OXYGEN,
            labelTime: timeKeys[OXYGEN],
          });
        }

        if (graphData[FEVER]) {
          data1 = graphData[FEVER];

          let dataset = [
            {
              label: 'Temperature',
              fill: true,
              backgroundColor: '#AB0D22',
              borderColor: '#AB0D22',
              pointBorderColor: '#AB0D22',
              pointBackgroundColor: '#fff',
              borderWidth: 5,
              type: 'line',
              fill: false,
              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: realKeys[FEVER],
            datasets: dataset,
            type: FEVER,
            labelTime: timeKeys[FEVER],
          });
        }

        if (graphData[EAT_OUT]) {
          data1 = graphData[EAT_GOOD];
          data2 = graphData[EAT_OUT];

          let dataset = [
            {
              label: 'Eating out',
              fill: true,
              backgroundColor: '#AB0D22',
              borderColor: '#AB0D22',
              pointBorderColor: '#AB0D22',
              pointBackgroundColor: '#fff',
              borderWidth: 5,
              type: 'line',
              fill: false,
              data: data2,
            },
            {
              label: 'Fruits/Veg',
              fill: true,
              backgroundColor: '#A4B370',
              borderColor: '#A4B370',
              pointBorderColor: '#A4B370',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              data: data1,
            },
          ];
          this.state.graphs.push({
            labels: realKeys[EAT_OUT],
            datasets: dataset,
            type: EAT_OUT,
            labelTime: timeKeys[EAT_OUT],
          });
        }

        if (graphData[PHQ9]) {
          let phq9Keys = [];
          let phq9Time = [];

          // group the answers by day
          data1 = graphData[PHQ9].reduce((acc, group, index) => {
            phq9Time.push(graphData[PHQ9][index][0].dateTime);
            phq9Keys.push(graphData[PHQ9][index][0].date);
            acc.push(Api.getDepressionScore(group, 'phq9'));
            return acc;
          }, []);

          let dataset = [
            {
              label: 'PHQ-9',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              data: data1,
            },
          ];

          this.state.graphs.push({ labels: phq9Keys, datasets: dataset, type: PHQ9, labelTime: phq9Time });
        }

        if (graphData[FIBSER]) {
          let fibserKeys = [];
          let fibserTime = [];

          // group the answers by day
          data1 = graphData[FIBSER].reduce((acc, group, index) => {
            fibserTime.push(graphData[FIBSER][index][0].dateTime);
            fibserKeys.push(graphData[FIBSER][index][0].date);
            acc.push(Api.getDepressionScore(group, 'fibser'));
            return acc;
          }, []);

          let dataset = [
            {
              label: 'FIBSER',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              lineTension: 0,
              data: data1,
            },
          ];

          this.state.graphs.push({ labels: fibserKeys, datasets: dataset, type: FIBSER, labelTime: fibserTime });
        }

        if (graphData[WEIGHT]) {
          data1 = graphData[WEIGHT];
          let dataset = [
            {
              label: 'Weight',
              fill: true,
              backgroundColor: 'rgba(0,49,229,.5)',
              borderColor: 'rgba(0,49,229,.5)',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#fff',
              pointRadius: 5,
              pointHitRadius: 10,
              data: data1,
            },
          ];

          this.state.graphs.push({
            labels: realKeys[WEIGHT],
            datasets: dataset,
            type: WEIGHT,
            labelTime: timeKeys[WEIGHT],
          });
        }

        this.setState({});
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({ chartVisible: true });
  }

  formatDate(isoFormatDateString) {
    var dateParts = isoFormatDateString.split('-');
    var jsDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0, 2));
    return jsDate.getMonth() + '/' + jsDate.getDate() + '/' + jsDate.getFullYear();
  }

  showGraph(data) {
    alert(data.t_code);
  }

  render() {
    return <div className={'container ' + (this.props.extraClass ? this.props.extraClass : '')}>{this.getChart()}</div>;
  }
}
